import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import { c as classNames } from '../../shared/bind-56cf2a3b.js';
import DefaultIcon from './assets/DefaultIcon.js';
import Icon from '../Icon/Icon.js';
import { CloseTarget } from '../../constants/portal.js';
import { ColorCode } from '../../constants/ui.js';
import { noop } from '../../utils/noop.js';
import { onA11yKeyDown } from '../../utils/a11y/onA11yKeyDown.js';
import { KeyboardKey } from '../../constants/keyboard.js';
import { getTestId } from '../../utils/testId.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { C as CheckCircleFilled24, E as ExclamationCircleFilled24 } from '../../shared/ExclamationCircleFilled24-6db48bf7.js';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import * as React from 'react';
import { X as X12 } from '../../shared/X12-07c64215.js';
import { ButtonWithForwardedRef } from '../Button/Button.js';

var _excluded = ["title", "titleId"];
var ExclamationTriangleFilled24 = function ExclamationTriangleFilled24(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("g", {
    clipPath: "url(#ExclamationTriangleFilled24__a)"
  }, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "m1.303 18.655 8.895-15.583a2.05 2.05 0 0 1 3.604 0l8.895 15.583c.84 1.472-.168 3.345-1.801 3.345H3.104c-1.633 0-2.642-1.873-1.801-3.345M13 13V8.5a1 1 0 1 0-2 0V13a1 1 0 1 0 2 0m-1 3a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
  })), /* @__PURE__ */React.createElement("defs", null, /* @__PURE__ */React.createElement("clipPath", {
    id: "ExclamationTriangleFilled24__a"
  }, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))));
};
ExclamationTriangleFilled24.Size = 24;
ExclamationTriangleFilled24.Title = "ExclamationTriangleFilled";

var styles = {
  "unit-base": "4",
  "info": "web_ui__InfoBanner__info",
  "body": "web_ui__InfoBanner__body",
  "success": "web_ui__InfoBanner__success",
  "warning": "web_ui__InfoBanner__warning",
  "error": "web_ui__InfoBanner__error",
  "default": "web_ui__InfoBanner__default",
  "narrow": "web_ui__InfoBanner__narrow",
  "tight": "web_ui__InfoBanner__tight",
  "wide": "web_ui__InfoBanner__wide",
  "banner": "web_ui__InfoBanner__banner",
  "prefix": "web_ui__InfoBanner__prefix",
  "prefix-info": "web_ui__InfoBanner__prefix-info",
  "content": "web_ui__InfoBanner__content",
  "inner_content": "web_ui__InfoBanner__inner_content",
  "title": "web_ui__InfoBanner__title",
  "suffix": "web_ui__InfoBanner__suffix",
  "actions": "web_ui__InfoBanner__actions"
};

var Styling = /*#__PURE__*/function (Styling) {
  Styling["Default"] = "default";
  Styling["Narrow"] = "narrow";
  Styling["Tight"] = "tight";
  Styling["Wide"] = "wide";
  return Styling;
}(Styling || {});
var Type = /*#__PURE__*/function (Type) {
  Type["Info"] = "info";
  Type["Success"] = "success";
  Type["Warning"] = "warning";
  Type["Error"] = "error";
  return Type;
}({});
var TYPE_ICON_MAP = _defineProperty(_defineProperty(_defineProperty({}, Type.Success, {
  name: CheckCircleFilled24,
  color: ColorCode.Success
}), Type.Warning, {
  name: ExclamationTriangleFilled24,
  color: ColorCode.Expose
}), Type.Error, {
  name: ExclamationCircleFilled24,
  color: ColorCode.Warning
});
var typeToThemeMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Type.Info, undefined), Type.Success, 'success'), Type.Warning, 'expose'), Type.Error, 'warning');
var cssClasses = classNames.bind(styles);
var InfoBanner = function InfoBanner(_ref) {
  var _ref$styling = _ref.styling,
    styling = _ref$styling === void 0 ? Styling.Default : _ref$styling,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Type.Info : _ref$type,
    _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? [] : _ref$actions,
    title = _ref.title,
    body = _ref.body,
    closable = _ref.closable,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? noop : _ref$onClose,
    aria = _ref.aria,
    testId = _ref.testId,
    closeButtonAriaLabel = _ref.closeButtonAriaLabel,
    width = _ref.width;
  var handleCloseButtonClick = function handleCloseButtonClick() {
    onClose(CloseTarget.CloseIcon);
  };
  var handleKeyDown = function handleKeyDown(event) {
    onA11yKeyDown(event, {
      keys: [KeyboardKey.Space, KeyboardKey.Enter]
    });
  };
  var renderButton = function renderButton(_ref2, isInverse, testIdPrefix) {
    var text = _ref2.text,
      _ref2$callback = _ref2.callback,
      callback = _ref2$callback === void 0 ? noop : _ref2$callback,
      url = _ref2.url;
    return /*#__PURE__*/jsx(ButtonWithForwardedRef, {
      inline: true,
      inverse: isInverse,
      onClick: callback,
      size: ButtonWithForwardedRef.Size.Small,
      text: text,
      theme: typeToThemeMap[type],
      styling: ButtonWithForwardedRef.Styling.Filled,
      testId: testIdPrefix,
      url: url
    });
  };
  var renderActions = function renderActions() {
    if (!actions.length) return null;
    return /*#__PURE__*/jsxs("div", {
      className: styles.actions,
      children: [renderButton(actions[0], false, getTestId(testId, 'primary-button')), !!actions[1] && renderButton(actions[1], true, getTestId(testId, 'secondary-button'))]
    });
  };
  var bannerClass = cssClasses('banner', type, styling);
  var customStyle = width ? {
    width: "".concat(width, "px")
  } : undefined;
  var renderTitle = function renderTitle() {
    if (!title) return null;
    return /*#__PURE__*/jsx("h4", {
      className: styles.title,
      children: title
    });
  };
  var renderBody = function renderBody() {
    return /*#__PURE__*/jsx("div", {
      className: styles.body,
      children: body
    });
  };
  var renderPrefix = function renderPrefix() {
    var iconProps = TYPE_ICON_MAP[type];
    return iconProps ? /*#__PURE__*/jsx("div", {
      className: styles.prefix,
      children: /*#__PURE__*/jsx(Icon, {
        name: iconProps.name,
        color: iconProps.color
      })
    }) : /*#__PURE__*/jsx("div", {
      className: styles.prefix,
      children: /*#__PURE__*/jsx("span", {
        className: styles['prefix-info'],
        children: /*#__PURE__*/jsx(DefaultIcon, {})
      })
    });
  };
  var renderSuffix = function renderSuffix() {
    if (!closable) return null;
    return /*#__PURE__*/jsx("div", {
      "aria-label": closeButtonAriaLabel,
      role: "button",
      tabIndex: 0,
      className: styles.suffix,
      onClick: handleCloseButtonClick,
      onKeyDown: handleKeyDown,
      "data-testid": getTestId(testId, 'close-button'),
      children: /*#__PURE__*/jsx(Icon, {
        name: X12
      })
    });
  };
  return /*#__PURE__*/jsxs("div", {
    className: bannerClass,
    "data-testid": testId,
    children: [/*#__PURE__*/jsxs("div", _objectSpread(_objectSpread({
      className: styles.content,
      style: customStyle
    }, aria), {}, {
      "data-testid": getTestId(testId, 'content'),
      children: [renderPrefix(), /*#__PURE__*/jsxs("div", {
        className: styles.inner_content,
        "data-testid": getTestId(testId, 'inner-content'),
        children: [renderTitle(), renderBody(), renderActions()]
      })]
    })), renderSuffix()]
  });
};
InfoBanner.Styling = Styling;
InfoBanner.Type = Type;

export { Type, InfoBanner as default };
//# sourceMappingURL=InfoBanner.js.map
